import { create } from "zustand";
import t from "../locales";
import picture_01 from "../assets/images/you_share/share_pic_01_barcelona.png";
import picture_02 from "../assets/images/you_share/share_pic_02_duivels.png";
import picture_03 from "../assets/images/you_share/share_pic_03_chiro.png";
import picture_04 from "../assets/images/you_share/share_pic_04_eten.png";
import picture_05 from "../assets/images/you_share/share_pic_05_living.png";
import picture_06 from "../assets/images/you_share/share_pic_06_chirokamp.png";
import picture_07 from "../assets/images/you_share/share_pic_07_festival.png";
import picture_08 from "../assets/images/you_share/share_pic_08_travel.png";

export const usePicturesStore = create((set) => ({
  savedPictures: [],
  savePicture: (key) =>
    set((state) => ({ savedPictures: [...state.savedPictures, key] })),
}));

export const pictures = [
  {
    key: "picture_01",
    file: picture_01,
    comment: t("youshare_picture_01_comment"),
    hashtags: [
      {
        label: t("youshare_picture_01_hashtag01"),
        saveInNotepad: "holiday",
      },
      {
        label: t("youshare_picture_01_hashtag02"),
      },
    ],
    filename: "IMG_0982",
    date: t("youshare_picture_01_date"),
    camera: "Back Camera --- 29 mm",
    filesize: "9MP - RES - 1.2MB",
  },
  {
    key: "picture_02",
    file: picture_02,
    comment: t("youshare_picture_02_comment"),
    hashtags: [
      {
        label: t("youshare_picture_02_hashtag01"),
      },
    ],
    filename: "IMG_0432",
    date: t("youshare_picture_02_date"),
    camera: "Front Camera --- 25 mm",
    filesize: "8.3MP - RES - 1.1MB",
  },
  {
    key: "picture_03",
    file: picture_03,
    comment: t("youshare_picture_03_comment"),
    hashtags: [
      {
        label: t("youshare_picture_03_hashtag01"),
      },
      {
        label: t("youshare_picture_03_hashtag02"),
      },
    ],
    filename: "IMG_02122",
    date: t("youshare_picture_03_date"),
    camera: "Front Camera --- 19 mm",
    filesize: "4MP - RES - 1.2MB",
  },
  {
    key: "picture_04",
    file: picture_04,
    comment: t("youshare_picture_04_comment"),
    hashtags: [
      {
        label: t("youshare_picture_04_hashtag01"),
      },
    ],
    filename: "IMG_0381",
    date: t("youshare_picture_04_date"),
    camera: "Back Camera --- 29 mm",
    filesize: "7.5MP - RES - 1MB",
  },
  {
    key: "picture_05",
    file: picture_05,
    comment: t("youshare_picture_05_comment"),
    hashtags: [
      {
        label: t("youshare_picture_05_hashtag01"),
      },
    ],
    filename: "IMG_0562",
    date: t("youshare_picture_05_date"),
    camera: "Back Camera --- 22 mm",
    filesize: "8.1MP - RES - 1.1MB",
    foundLocation: {
      street: t("youfind_found_street"),
      cityname: t("youfind_found_cityname"),
      city: t("secrets_city_value"),
    },
  },
  {
    key: "picture_06",
    file: picture_06,
    comment: t("youshare_picture_06_comment"),
    hashtags: [
      {
        label: t("youshare_picture_06_hashtag01"),
      },
      {
        label: t("youshare_picture_06_hashtag02"),
      },
      {
        label: t("youshare_picture_06_hashtag03"),
      },
    ],
    filename: "IMG_1211",
    date: t("youshare_picture_06_date"),
    camera: "Back Camera --- 29 mm",
    filesize: "6MP - RES - 0.9MB",
  },
  {
    key: "picture_07",
    file: picture_07,
    comment: t("youshare_picture_07_comment"),
    hashtags: [
      {
        label: t("youshare_picture_07_hashtag01"),
      },
    ],
    filename: "IMG_7141",
    date: t("youshare_picture_07_date"),
    camera: "Back Camera --- 29 mm",
    filesize: "7MP - RES - 1.2MB",
  },
  {
    key: "picture_08",
    file: picture_08,
    comment: t("youshare_picture_08_comment"),
    hashtags: [
      {
        label: t("youshare_picture_08_hashtag01"),
      },
      {
        label: t("youshare_picture_08_hashtag02"),
      },
    ],
    filename: "IMG_0781",
    date: t("youshare_picture_08_date"),
    camera: "Back Camera --- 29 mm",
    filesize: "9MP - RES - 1MB",
  },
];
